// removed by extract-text-webpack-plugin
module.exports = {"runColor":"#0076C0","fitnessColor":"#375A92","borderGray":"#D3D6DC","container":"container-33o3x","button":"button-3l1f0","disabled":"disabled-qXPsi","active":"active-1C7ng","bookends":"bookends-2LzOT","ellipsis":"ellipsis-2As-g","next":"next-2ykbi","prev":"prev-2EekU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/_paginatorControls.css
// module id = 1282
// module chunks = 1